export default "\n<div class=\"row\" >\n  <div class=\"col-12\">\n      <p style=\"text-align: center\">{{'hello_info' | translate}}</p>\n  </div>\n</div>\n\n"